<template>
    <BusinessOmniplayEventsCoreVue :dateDimension="dateDimension"></BusinessOmniplayEventsCoreVue>
</template>


<script>


import BusinessOmniplayEventsCoreVue, { BusinessOmniplayEventsCore } from '@/views/events/core/BusinessOmniplayEventsCore.vue';
import { BusinessOmniplayEventsOrder } from '@/router/routeNames';
import dimensionEnum from '@/model/dimensionEnum';



export default {
    name: BusinessOmniplayEventsOrder,
    data() {
        return {
            dateDimension: dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE
        };
    },
    mounted() {
    },
    computed: {},
    methods: {},
    components: { BusinessOmniplayEventsCoreVue }
}

</script>